import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 15,
	viewBox: "0 0 19 15",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M11.1429 1.28577L17.5714 7.71434M17.5714 7.71434L11.1429 14.1429M17.5714 7.71434L0.428589 7.71433" })
});
export default SvgIconArrowRight;
